import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { convertToPascal, displayConsoleLog, displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, screenCaptureAnalytics } from "../../../../utils/Utils";
import { countryListRequest, stateListRequest, cityListRequest } from '../../../../redux/user/user.action'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../../utils/AppConstants";
import Select from 'react-select'
import { useLocation, useNavigate } from 'react-router-dom';
import { CurrencyLabel } from "../../../../utils/CurrencyLabel";
import { updateBusinessLocationDetailRequest, updateBusinessLocationDetailRequestStatus, businessLocationDetailRequest } from '../../../../redux/business-location/businessLocation.action'
import { userBusinessListRequest } from '../../../../redux/business/business.action'
import CommonScreenContent from "../../../../components/screen/common-screen-content/commonScreenContent";
import CommonFormBorder from "../../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../../components/input/common-input-float-full/commonInputFloatFull";
import FormFieldLabel from "../../../../components/label/form-field-label/formFieldLabel";
import ButtonRow from "../../../../components/button/button-row/buttonRow";
import CommonButton from "../../../../components/button/common-button/commonButton";
import ScreenLabel from "../../../../components/label/screen-label/screenLabel";

const EditLocationScreen = props => {
    const [selectedCurrency, setSelectedCurrency] = useState()
    const [countryDropdown, setCountryDropdown] = useState();
    const [stateDropdown, setStateDropdown] = useState();
    const [cityDropdown, setCityDropdown] = useState();
    const [countryCode, setCountryCode] = useState('')
    const [name, setName] = useState('')
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { user, countryListSuccess, countryListError, stateListSuccess, stateListError,
        cityListSuccess, cityListError, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationDetailSuccess, businessLocationDetailError,
        updateBusinessLocationDetailSuccess, updateBusinessLocationDetailError, updateBusinessLocationDetailReqStatus } = useSelector(state => state.businessLocation)
    const { state } = useLocation()
    let navigate = useNavigate()
    const [address, setAddress] = useState('')

    useEffect(() => {
        fetchLocationDetail()
        setLoading(true)
        dispatch({ type: APP_CONSTANTS.RESET_STATE_CITY })
        dispatch(countryListRequest())
        if (isLoggedInUserBusiness(user) === true) {
            const data = {
                userId: user.data.userDetails.userId
            }
            dispatch(userBusinessListRequest(data))
        }

    }, [])

    const fetchLocationDetail = () => {
        setLoading(true)
        dispatch(businessLocationDetailRequest(state))
    }

    useEffect(() => {
        if (!isNull(userBusinessListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isNull(businessLocationDetailSuccess)) {
            setLoading(false)
            setName(businessLocationDetailSuccess.data.name)
            setAddress(businessLocationDetailSuccess.data.address)
            if (!isEmpty(businessLocationDetailSuccess.data.currencyLabel)) {
                const curr = CurrencyLabel.find(e => e.code === businessLocationDetailSuccess.data.currencyLabel)
                if (!isEmpty(curr)) {
                    setSelectedCurrency(curr)
                }
            }
        } else if (!isEmpty(businessLocationDetailError)) {
            setLoading(false)
        }
    }, [businessLocationDetailSuccess, businessLocationDetailError])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess) && !isEmpty(businessLocationDetailSuccess)) {
            const business = userBusinessListSuccess.data.find(item => parseFloat(item.businessId) === parseFloat(businessLocationDetailSuccess.data.businessId))
            if (!isEmpty(business)) {
                setSelectedBusiness(business)
            }
        }
    }, [userBusinessListSuccess, businessLocationDetailSuccess])

    useEffect(() => {
        if (!isNull(countryListSuccess)) {
            setLoading(false)
            if (!isEmpty(businessLocationDetailSuccess)) {
                const country = countryListSuccess.find(item => item.iso2 === businessLocationDetailSuccess.data.countryCode)
                if (!isEmpty(country)) {
                    setCountryDropdown(country)
                }
            }
        } else if (!isEmpty(countryListError)) {
            setLoading(false)
        }
    }, [countryListSuccess, countryListError])

    useEffect(() => {
        if (!isNull(stateListSuccess)) {
            setLoading(false)
            if (!isEmpty(businessLocationDetailSuccess)) {
                const state = stateListSuccess.find(item => item.iso2 === businessLocationDetailSuccess.data.stateCode)
                if (!isEmpty(state)) {
                    setStateDropdown(state)
                }
            }
        } else if (!isEmpty(stateListError)) {
            setLoading(false)
        }
    }, [stateListSuccess, stateListError])

    useEffect(() => {
        if (!isNull(cityListSuccess)) {
            setLoading(false)
            if (!isEmpty(businessLocationDetailSuccess)) {
                const city = cityListSuccess.find(item => item.name === businessLocationDetailSuccess.data.city)
                if (!isEmpty(city)) {
                    setCityDropdown(city)
                }
            }
        } else if (!isEmpty(cityListError)) {
            setLoading(false)
        }
    }, [cityListSuccess, cityListError])

    const fetchStateList = (countryId) => {
        setLoading(true)
        const data = {
            countryId: countryId
        }
        dispatch(stateListRequest(data))
    }

    const fetchCityList = (countryId, stateId) => {
        setLoading(true)
        const data = {
            countryId: countryId,
            stateId: stateId
        }
        dispatch(cityListRequest(data))
    }

    useEffect(() => {
        if (!isNull(countryDropdown)) {
            setCountryCode(countryDropdown.iso2)
            fetchStateList(countryDropdown.iso2)
        }
    }, [countryDropdown])

    useEffect(() => {
        if (!isNull(stateDropdown)) {
            fetchCityList(countryCode, stateDropdown.iso2)
        }
    }, [stateDropdown])

    useEffect(() => {
        if (updateBusinessLocationDetailReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateBusinessLocationDetailSuccess.data.message)
            fetchLocationDetail()
        } else if (updateBusinessLocationDetailReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateBusinessLocationDetailError.message)
        }

        if (updateBusinessLocationDetailReqStatus?.length) {
            dispatch(updateBusinessLocationDetailRequestStatus(''))
        }
    }, [updateBusinessLocationDetailSuccess, updateBusinessLocationDetailError, updateBusinessLocationDetailReqStatus])

    const clearFields = () => {
        setName('')
    }

    const submitHandler = () => {
        if (isEmpty(name)) {
            displayErrorToast('Location name cannot be blank')
        } else if (isEmpty(address)) {
            displayErrorToast('Location address cannot be blank')
        } else {
            setLoading(true)
            const data = {
                name: name,
                locationId: state,
                address: address
            }
            if (!isNull(countryDropdown)) {
                data.country = countryDropdown.name
                data.countryCode = countryDropdown.iso2
            }
            if (!isNull(stateDropdown)) {
                data.state = stateDropdown.name
                data.stateCode = stateDropdown.iso2
            }
            if (!isNull(cityDropdown)) {
                data.city = cityDropdown.name
            }
            if (!isNull(selectedCurrency)) {
                data.currencyLabel = selectedCurrency.code
                data.currencySymbol = selectedCurrency.symbol
                data.currencyRegion = selectedCurrency.region
            }
            dispatch(updateBusinessLocationDetailRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Update Details' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to update location details' />
                    <CommonInputFloatFull
                        type="name"
                        id="name"
                        placeholder="Location Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        isRequired={true}
                    />
                    <CommonInputFloatFull
                        type="name"
                        id="address"
                        placeholder="Address"
                        value={address}
                        onChange={e => setAddress(e.target.value)}
                        isRequired={true}
                        subText='Stree address only'
                        isSubtext={true}
                    />
                    {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectedBusiness}
                        getOptionLabel={e => e.businessName}
                        getOptionValue={e => e}
                        options={userBusinessListSuccess.data}
                        placeholder='Select Business'
                        onChange={e => setSelectedBusiness(e)} />}
                    {isLoggedInUserBusiness(user) === true && !isEmpty(userBusinessListError) && <div>{userBusinessListError.message}</div>}
                    <FormFieldLabel className='up-bold-label' label='Currency Information' />
                    {CurrencyLabel && <Select
                        menuPlacement="auto"
                        className='select-full-width-no-border'
                        value={selectedCurrency}
                        getOptionLabel={e => `${e.currency} (${e.symbol})`}
                        getOptionValue={e => e}
                        options={CurrencyLabel}
                        placeholder='Select Currency'
                        onChange={e => {
                            setSelectedCurrency(e)
                        }} />}
                    <FormFieldLabel className='up-bold-label' label='Location Information' />
                    {countryListSuccess && <Select
                        className='select-full-width-no-border'
                        value={countryDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={countryListSuccess}
                        placeholder='Select Country'
                        onChange={e => {
                            setCountryDropdown(e);
                        }} />}
                    {stateListSuccess && <Select
                        className='select-full-width-no-border'
                        value={stateDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={stateListSuccess}
                        placeholder='Select State'
                        onChange={e => {
                            setStateDropdown(e);

                        }} />}
                    {cityListSuccess && <Select
                        className='select-full-width-no-border'
                        value={cityDropdown}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e}
                        options={cityListSuccess}
                        placeholder='Select City'
                        onChange={e => {
                            setCityDropdown(e);
                        }} />}
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => submitHandler()} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EditLocationScreen